import en from './locales/en';

/** Admin UI strings in en/fr/es. The Shopify admin passes the staff locale as `?locale=` (e.g. `fr-CA`).
 * Strings live in `locales/`: English is bundled, French and Spanish are downloaded only when needed. */

export type Lang = 'en' | 'fr' | 'es';
export type Strings = Record<keyof typeof en, string>;

export function langFrom(locale: string | null | undefined): Lang {
  const base = (locale ?? '').toLowerCase().split(/[-_]/)[0];
  return base === 'fr' || base === 'es' ? base : 'en';
}

/** English at once; French and Spanish from their own chunk. */
export async function loadStrings(lang: Lang): Promise<Strings> {
  if (lang === 'fr') return (await import('./locales/fr')).default;
  if (lang === 'es') return (await import('./locales/es')).default;
  return en;
}

/** For text needed before the staff language has loaded (the loading spinner). */
export const ENGLISH: Strings = en;

/** Fills `{name}` placeholders: format(t.postsCount, { n: 15 }). */
export function format(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => (key in values ? String(values[key]) : match));
}
